export default {
	lang:'es',
	download:{
		"download01":"Ventanas",
		"download02":"Impermeable",
		"download03":"iOS",
		"download04":"Androide",
		"download05":"Descargar ahora",
		"download":"descargar",
		"download2":"Móvil",
		"download3":"Escanea el código QR para descargar iOS/Android",
		"download4":"Código QR",
		"download5":"Ventanas",
		"download6":"Compatible con Windows 10 de 64 bits y versiones posteriores",
		"download7":"macOS",
		"download8":"Compatible con macOS 10.14 y versiones posteriores",
		"download9":"Tienda de aplicaciones",
		"download10":"Compatible con macOS 10.14 y versiones posteriores",
		"download11":"Androide",
		"download12":"Compatible con Android 10.14 y superior",
	},
	home:{
		"home":"página delantera",
		"XiaobeiBigModel":"Modelo pequeño",
		"AIcapability":"Capacidades de IA",
		"Solution":"Solución",
		"ProductCenter":"Productos",
		"MediaCenter":"Medios",
		"AboutUs":"sobre nosotros",
		"Login/Regis":"Iniciar sesión/Registrarse",
		"home1":"Competencias básicas",
		"home2":"Línea directa de atención al cliente",
		"home3":"Número de contacto",
		"home14":"El empoderamiento de la IA, utilizando hardware inteligente como portador, proporciona capacidades y servicios integrales",
		"home15":"Algoritmo de rompecabezas",
		"home16":"Reconocimiento OCR",
		"home17":"Inteligencia artificial",
		"home18":"Reconocimiento de voz",
		"home19":"Diccionario autorizado",
		"home20":"Traducción de texto",
		"home21":"Traducción de fotografías",
		"home22":"Preguntas y respuestas generales",
		"home23":"Cursos en vídeo",
		"home24":"Xiaobei AI modelo grande",
		"home25":"La tecnología es la principal fuerza productiva",
		"home26":"Personal técnico",
		"home27":"Inversión en I+D",
		"home28":"Número de patentes",
		"home29":"(Porcentaje)",
		"home30":"(100 millones de yuanes)",
		"home31":"(artículo)",
		"home32":"Solución",
		"home33":"Ante las necesidades de aplicación de múltiples escenarios, como oficinas, educación y automóviles, BeiBo ofrece a sus clientes soluciones integrales basadas en sus propias capacidades de I+D y conceptos de servicio.",
		"home34":"Soluciones relacionadas",
		"home35":"Capacidades de productos relacionados",
		"home36":"Servicios de pila completa",
		"home37":"El empoderamiento de la IA, utilizando hardware inteligente como portador, proporciona capacidades y servicios integrales",
		"home38":"Investigación y desarrollo",
		"home39":"Producción",
		"home40":"Gestión de calidad",
		"home41":"Soporte posventa",
		"home42":"Equipo profesional de I+D de software y hardware, con muchos años de experiencia en I+D en OCR, reconocimiento de voz, traducción, IA e interacción persona-computadora.",
		"home43":"Fábrica de origen, cadena de suministro estable, producción de procesos inteligentes y estrictos.",
		"home44":"Los inspectores de calidad verifican cada paso e introducen el sistema de gestión ISO9001",
		"home45":"Establecer equipos profesionales de soporte posventa en el país y en el extranjero para brindar una respuesta oportuna, soluciones enfocadas y un servicio personalizado.",
		"home46":"Proceso de dar un título",
		"home47":"Más de 100 patentes nacionales y extranjeras",
		"home48":"Noticias",
		"home49":"Conozca nuestras últimas novedades",
		"home50":"Consulte los detalles",
		"home51":"Fogonadura",
		"home52":"Centrarse en el mercado de hardware de inteligencia artificial y brindar servicios profesionales OEM/0DM.",
		"home53":"Consulta de cooperación",
		"home54":"Oficina inteligente",
		"home55":"Educación inteligente",
		"home56":"Caja de coche inteligente",
		"home57":"Reconocimiento de voz",
		"home58":"Algoritmo de rompecabezas",
		"home59":"Reconocimiento OCR",
		"home60":"Síntesis de voz",
		"home61":"Traducción de texto",
		"home62":"Traducción de imágenes",
		"home63":"Traducción de voz",
		"home64":"Procesamiento del lenguaje natural",
		"home571":"Reconocimiento OCR",
		"home581":"Reconocimiento de voz ",
		"home591":"Traducción de voz",
		"home601":"Síntesis de voz",
		"home611":"Diccionario autorizado",
		"home621":"Cursos generales",
		"home631":"Preguntas y respuestas generales",
		"home641":"Procesamiento del lenguaje natural",
		"home572":"Reconocimiento de voz",
		"home582":"Síntesis de voz ",
		"home592":"Traducción de voz",
		"home602":"Procesamiento del lenguaje natural",
		"home603":"No más",
		
	},
	consult:{
		"tilte":"Le brindaremos con todo el corazón una gama completa de servicios de cooperación empresarial.",
		"subtilte":"Por favor deje su información de contacto y nos pondremos en contacto con usted lo antes posible.",
		"name":"Por favor, introduzca su nombre",
		"phone":"Por favor ingrese su número de teléfono",
		"mailbox":"Por favor ingrese su correo electrónico",
		"mailboxerr":"Error de formato de correo electrónico",
		"company":"Por favor ingrese su empresa",
		"desc":"Por favor ingrese sus requisitos",
		"but":"Confirmar envío",
		"region":"Porcelana",
		"select":"Por favor seleccione",
		"submitSuccess":"Enviar exitosamente",
		"submitError":"Envío fallido",
	},
	ProDetails:{
		"ProDetails1":"Proceso de personalización",
		"ProDetails2":"Centrarse en el mercado de hardware de inteligencia artificial y brindar servicios profesionales OEM/0DM.",
	},
	aiCapacity:{
		"aiMode1":"Capacidades de IA",
		"aiMode2":"Basándonos en tecnologías como big data, gráficos de conocimiento, aprendizaje automático y lingüística, continuamos innovando y enfocándonos en la investigación de tecnologías centrales de IA y la implementación de aplicaciones de hardware inteligente.",
		"aiMode3":"Consulta de cooperación",
		"aiMode4":"Competencias básicas",
		"aiMode5":"El empoderamiento de la IA, utilizando hardware inteligente como portador, proporciona capacidades y servicios integrales",
		"aiMode6":"Algoritmo de rompecabezas",
		"aiMode7":"Fusiona imágenes pequeñas fragmentadas en imágenes grandes para su reconocimiento, compatible con más de 50 idiomas",
		"aiMode8":"Reconocimiento OCR",
		"aiMode9":"Extrae texto mediante procesamiento de imágenes y reconocimiento de patrones. Compatible con más de 50 idiomas.",
		"aiMode10":"Reconocimiento de voz",
		"aiMode11":"Reconoce con precisión audios largos y cortos en texto. Compatible con más de 130 idiomas.",
		"aiMode12":"Síntesis de voz",
		"aiMode13":"Convierte texto en voz humana natural y fluida. Compatible con más de 130 idiomas.",
		"aiMode14":"Traducción de texto",
		"aiMode15":"Convierte texto del idioma de destino al idioma especificado. Compatible con más de 130 idiomas.",
		"aiMode16":"Traducción de imágenes",
		"aiMode17":"Reconocimiento y traducción de texto en imágenes. Compatible con más de 130 idiomas.",
		"aiMode18":"Traducción de voz",
		"aiMode19":"Reconoce y traduce con precisión audios largos y cortos. Compatible con más de 130 idiomas.",
		"aiMode20":"Procesamiento del lenguaje natural",
		"aiMode21":"Basándose en grandes datos, conocimiento y tecnología del lenguaje, se pueden realizar aplicaciones como la respuesta a preguntas y el diálogo.",
		"aiMode22":"Autoridad del diccionario",
		"aiMode23":"Cooperar profundamente con instituciones autorizadas para proporcionar diccionarios genuinos como Oxford, Longman y varios idiomas minoritarios.",
		"aiMode24":"Cursos en vídeo",
		"aiMode25":"Cursos en vídeo de temas completos, libros de texto actualizados simultáneamente, adecuados para vista previa y revisión",
		"aiMode26":"Preguntas y respuestas generales",
		"aiMode27":"Responder preguntas e interpretar preguntas en todas las materias, aprender por analogía y mejorar la eficiencia del aprendizaje.",
		"aiMode28":"Xiaobei AI modelo grande",
		"aiMode29":"Interacción multimodal",
		"aiMode30":"Interacción multimodal de texto, voz y vídeo",
		"aiMode31":"Capacidad de codificación",
		"aiMode32":"Generación, interpretación, depuración y pruebas de código",
		"aiMode33":"Generación de texto",
		"aiMode34":"Generación de ensayos, marketing, notas de prensa, etc.",
		"aiMode35":"Medicina general",
		"aiMode36":"Planteamiento de preguntas y resolución de problemas para todas las materias",
		"aiMode37":"Comprensión del lenguaje",
		"aiMode38":"Extracción de resúmenes, verificación gramatical y análisis de sentimientos.",
		"aiMode39":"Trivialidades",
		"aiMode40":"Conocimiento de la vida, el trabajo, la medicina y la historia.",
		"aiMode41":"Razonamiento lógico",
		"aiMode42":"Pensamiento, ciencia, razonamiento de sentido común.",
		"aiMode43":"Plurilingüe",
		"aiMode44":"Admite interacción en más de 100 idiomas.",
		"aiMode45":"Ventajas técnicas",
		"aiMode46":"200 millones de corpus precisos",
		"aiMode47":"Ampliamente utilizado en oficinas inteligentes, educación inteligente y cajas de automóviles inteligentes.",
		"aiMode48":"Tecnología colaborativa global",
		"aiMode49":"Latencia ultrabaja, seguridad y estabilidad, programación inteligente, enlace estable.",
		"aiMode50":"Sistema de cifrado de seguridad",
		"aiMode51":"Sistema de cifrado de cuatro dimensiones de datos de extremo de tubería en la nube líder a nivel internacional, cifrado de proceso completo",
	},
	aiMode:{
		"aiMode1":"Capacidades de IA",
		"aiMode2":"Basándonos en tecnologías como big data, gráficos de conocimiento, aprendizaje automático y lingüística, continuamos innovando y enfocándonos en la investigación de tecnologías centrales de IA y la implementación de aplicaciones de hardware inteligente.",
		"aiMode3":"Consulta de cooperación",
		"aiMode4":"Competencias básicas",
		"aiMode5":"El empoderamiento de la IA, utilizando hardware inteligente como portador, proporciona capacidades y servicios integrales",
		"aiMode6":"Algoritmo de rompecabezas",
		"aiMode7":"Fusiona imágenes pequeñas fragmentadas en imágenes grandes para su reconocimiento, compatible con más de 50 idiomas",
		"aiMode8":"Reconocimiento OCR",
		"aiMode9":"Extrae texto mediante procesamiento de imágenes y reconocimiento de patrones. Compatible con más de 50 idiomas.",
		"aiMode10":"Reconocimiento de voz",
		"aiMode11":"Reconoce con precisión audios largos y cortos en texto. Compatible con más de 130 idiomas.",
		"aiMode12":"Síntesis de voz",
		"aiMode13":"Convierte texto en voz humana natural y fluida. Compatible con más de 130 idiomas.",
		"aiMode14":"Traducción de texto",
		"aiMode15":"Convierte texto del idioma de destino al idioma especificado. Compatible con más de 130 idiomas.",
		"aiMode16":"Traducción de imágenes",
		"aiMode17":"Reconocimiento y traducción de texto en imágenes. Compatible con más de 130 idiomas.",
		"aiMode18":"Traducción de voz",
		"aiMode19":"Reconoce y traduce con precisión audios largos y cortos. Compatible con más de 130 idiomas.",
		"aiMode20":"Procesamiento del lenguaje natural",
		"aiMode21":"Basándose en grandes datos, conocimiento y tecnología del lenguaje, se pueden realizar aplicaciones como la respuesta a preguntas y el diálogo.",
		"aiMode22":"Autoridad del diccionario",
		"aiMode23":"Cooperar profundamente con instituciones autorizadas para proporcionar diccionarios genuinos como Oxford, Longman y varios idiomas minoritarios.",
		"aiMode24":"Cursos en vídeo",
		"aiMode25":"Cursos en vídeo de temas completos, libros de texto actualizados simultáneamente, adecuados para vista previa y revisión",
		"aiMode26":"Preguntas y respuestas generales",
		"aiMode27":"Responder preguntas e interpretar preguntas en todas las materias, aprender por analogía y mejorar la eficiencia del aprendizaje.",
		"aiMode28":"Xiaobei AI modelo grande",
		"aiMode29":"Interacción multimodal",
		"aiMode30":"Interacción multimodal de texto, voz y vídeo",
		"aiMode31":"Capacidad de codificación",
		"aiMode32":"Generación, interpretación, depuración y pruebas de código",
		"aiMode33":"Generación de texto",
		"aiMode34":"Generación de ensayos, marketing, notas de prensa, etc.",
		"aiMode35":"Medicina general",
		"aiMode36":"Planteamiento de preguntas y resolución de problemas para todas las materias",
		"aiMode37":"Comprensión del lenguaje",
		"aiMode38":"Extracción de resúmenes, verificación gramatical y análisis de sentimientos.",
		"aiMode39":"Trivialidades",
		"aiMode40":"Conocimiento de la vida, el trabajo, la medicina y la historia.",
	},
	Product:{
		"Product1":"Centro de productos",
		"Product2":"Productos inteligentes para oficina, educación y vehículos que admiten pedidos y personalización de funciones.",
		"Product3":"Consulta de cooperación",
	},
	medium:{
		"medium1":"Centro de medios",
		"medium2":"Las últimas noticias de BeiBo, por favor vea aquí",
		"medium3":"Consulta de cooperación",
	},
	about:{
		"about1":"Más información sobre BeiBo",
		"about2":"Proveedor de soluciones de hardware inteligente para oficinas, educación, cajas de automóviles, etc.",
		"about3":"Consulta de cooperación",
		"about4":"Perfil de la empresa",
		"about5":"Proceso de dar un título",
		"about6":"Más de 100 patentes nacionales y extranjeras",
		"about7":"Shenzhen Beibo Tecnología Inteligente Co., Ltd.",
		"about8":`Fundada en 2015 y con sede en Shenzhen, el centro de "fabricación inteligente" de China, BeiBo Intelligent es una empresa nacional de alta tecnología y una empresa especializada e innovadora con una visión de futuro y un espíritu innovador.`,
		"about9":`La empresa se centra en el segmento vertical de voz de IA y cuenta con sólidas capacidades de I+D de software y hardware de IA. Potencia el hardware de IA exportando tecnologías de IA como voz de IA, traducción de IA, OCR de IA, interacción humano-vehículo de IA y nube de IA. La empresa desarrolla su propio modelo de IA de traducción de voz, integra las últimas tecnologías multimodales de IA y AIGC, y proporciona soluciones integrales de tecnología de voz de IA para clientes en diferentes campos basadas en la I+D y el diseño de plataformas de chips y soluciones de hardware. En los campos de la educación, el gobierno, las empresas y el ejército, la empresa cuenta con soluciones industriales maduras; en el lado del consumidor, las ventas anuales de hardware de IA como traductores de IA, grabadoras de voz de IA, escáneres de IA y cajas de automóviles de IA superan el millón de unidades. La empresa tiene múltiples socios estratégicos en Japón, Europa, Estados Unidos y otros países y regiones para ayudar a las personas a superar las barreras del idioma, y es un proveedor líder mundial de soluciones de tecnología de voz de IA.`,
		"about10":"",
	},
	footer:{
		"AboutUs":"sobre nosotros",
		"CollaborativeConsulting":"Consulta de cooperación",
		"Businesscooperation":"Cooperación empresarial",
		"phone":"Por favor ingrese su número de teléfono",
		"phone2":"+86 13660736734",
		"phone3":"hangou@szbbzn.com",
		"tel":"0755 27189290",
		"address":"Sala 201, Edificio F, Zona Industrial Yuanfen, Comunidad Taoyuan, Calle Dalang, Distrito Longhua, Shenzhen",
		"copyright":"Derechos de autor © Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"icp":"N.º de ICP de Guangdong: 2024241358-1",
		"footer2":"Bienvenido a registrarse",
		"footer3":"¿Ya tienes una cuenta?",
		"footer4":"Por favor inicia sesión",
	},
	login:{
		"login1":"Iniciar sesión con contraseña",
		"login2":"Inicio de sesión por SMS",
		"loginTab3":"Inicio de sesión por correo electrónico",
		"login3":"Correo",
		"login4":"Contraseña de inicio de sesión",
		"login5":"Número de teléfono",
		"login6":"Por favor seleccione",
		"login7":"Código de verificación móvil",
		"login8":"Acceso",
		"login9":"Olvidé la contraseña",
		"login10":"registro",
		"login11":"Al iniciar sesión, aceptas",
		"login12":"Acuerdo de servicio",
		"login13":"política de privacidad",
		"login14":"Conseguir",
		"login15":"Porcelana",
		"login16":"Por favor ingrese su número de cuenta",
		"login17":"Por favor, introduzca su contraseña",
		"login18":"¡Inicio de sesión exitoso!",
		"login19":"¡Por favor ingrese el código de verificación!",
		"login20":"¡Enviado exitosamente!",
		"login21":"y",
		"login22":"Disco en la nube de grabadora de voz",
		"login23":"Mi escritura",
		"login24":"Mi conversación",
		"login25":"Seguridad de la cuenta",
		"login26":"Finalizar la sesión",
		"login27":"Recuperar contraseña por correo electrónico",
		"login28":"Correo",
		"login29":"Código de verificación de correo electrónico",
		"login30":"Establecer una contraseña de inicio de sesión (6-16 caracteres)",
		"login31":"Vuelva a ingresar su contraseña de inicio de sesión",
		"login32":"entregar",
		"login33":"Volver al inicio de sesión",
		"login34":"¡Modificación exitosa!",
	},
	register:{
		"register1":"Número de teléfono",
		"register2":"Por favor ingrese su número de teléfono",
		"register3":"Por favor seleccione",
		"register4":"Código de verificación móvil",
		"register5":"Establecer contraseña",
		"register6":"Por favor, introduzca el código de verificación",
		"register7":"6-16 caracteres",
		"register8":"Confirmación de contraseña",
		"register9":"Correo",
		"register10":"Por favor, introduzca su dirección de correo electrónico",
		"register11":"Código de verificación de correo electrónico",
		"register12":"Por favor, introduzca el código de verificación",
		"register13":"He leído y estoy de acuerdo",
		"register14":"Por favor, lea y marque la casilla que acepta el acuerdo.",
		"register15":"El formato del número de teléfono es incorrecto/el número de teléfono ha sido registrado",
		"register16":"Error del código de verificación móvil",
		"register17":"Ingrese su dirección de correo electrónico / El formato de la dirección de correo electrónico es incorrecto",
		"register18":"Error de formato de correo electrónico",
		"register19":"Error en el código de verificación de correo electrónico",
		"register20":"Establezca la contraseña entre 6 y 16 caracteres.",
		"register21":"Error de formato de contraseña",
		"register22":"Las contraseñas que ingresó dos veces no coinciden. Vuelva a ingresarlas.",
		"register23":"Por favor, introduzca su contraseña",
		"register24":"¡Registro exitoso!",
		"register25":"Error de código de verificación",
	},
	recorder:{
		"recorder1":"Disco en la nube de grabadora de voz",
		"recorder2":"Capacidad de espacio en la nube",
		"recorder3":"documento",
		"recorder331":"Papelera de reciclaje",
		"recorder332":"Borrar todo",
		"recorder4":"nombre",
		"recorder5":"Duración del audio",
		"recorder6":"Tamaño del archivo",
		"recorder7":"Tiempo de creación",
		"recorder8":"funcionar",
		"recorder9":"Descripción del espacio en la nube",
		"recorder10":"documento",
		"recorder11":"Archivo OCR",
		"recorder12":"1. ¿Para qué se utiliza el espacio en la nube?",
		"recorder13":"Después de grabar con la grabadora, puedes subir los archivos de audio y transcripción a la nube. Incluso si no tienes la grabadora, puedes acceder a la nube para ver el audio.",
		"recorder14":"2. ¿Cómo subir al espacio en la nube?",
		"recorder15":"Vaya a [Mis archivos] en la grabadora, seleccione el archivo de destino y mantenga presionado para mostrar las opciones, luego haga clic en Cargar para cargar el archivo al espacio en la nube.",
		"recorder16":"3. ¿Cómo ver/administrar archivos de espacio en la nube?",
		"recorder17":"Inicia sesión en el sitio web oficial de BeiBo, selecciona My-Recorder Cloud Disk y podrás ver los archivos de la grabadora cargados. Puedes seleccionar el archivo que deseas descargar, eliminar, etc. ¡Puedes liberar espacio en la nube eliminando los archivos!",
		"recorder18":"No transcrito",
		"recorder19":"Ver resumen",
		"recorder20":"Vocero",
		"recorder21":"Editar el nombre del orador",
		"recorder22":"Seguro",
		"recorder23":"descargar",
		"recorder24":"Descargar contenido:",
		"recorder25":"Configuración de descarga:",
		"recorder26":"Mostrar orador",
		"recorder27":"Cancelar",
		"recorder28":"Compartir enlaces",
		"recorder29":"Cualquiera que obtenga el enlace puede acceder. Es solo para lectura y tiene una validez de 7 días.",
		"recorder30":"Copiar enlace",
		"recorder31":"Escanee y visualice rápidamente",
		"recorder32":"Organización inteligente",
		"recorder33":"Diferenciar entre hablantes",
		"recorder34":"Distinguir inteligentemente el texto transcrito según el rol del hablante",
		"recorder35":"Regularización inteligente del lenguaje hablado",
		"recorder36":"Filtra automáticamente partículas modales, palabras repetidas y palabras de pausa.",
		"recorder37":"Filtrado no vocal",
		"recorder38":"Salta automáticamente el audio sin voz ni ruido durante la reproducción",
		"recorder39":"Por favor seleccione",
		"recorder40":"documento",
		"recorder41":"Audio",
		"recorder42":"Documentos + Audio",
		"recorder43":"pista",
		"recorder44":"Esta operación eliminará archivos, ¿desea continuar?",
		"recorder441":"Esta operación eliminará todos los archivos, ¿desea continuar?",
		"recorder45":"Seguro",
		"recorder46":"Cancelar",
		"recorder47":"¡Eliminado exitosamente!",
		"recorder48":"No eliminado",
		"recorder49":"No hay etiquetas todavía",
		"recorder50":"Ahorro...",
		"recorder51":"Papelera de reciclaje",
	},
	personal:{
		"personal1":"Configuraciones de la cuenta",
		"personal2":"información personal",
		"personal3":"avatar",
		"personal4":"Subir archivos",
		"personal5":"Admite estilos JPG, JPEG, GIF, PNG, admite imágenes de hasta 2 M",
		"personal6":"Apodo",
		"personal7":"Por favor ingrese su apodo",
		"personal8":"género",
		"personal9":"caballeros",
		"personal10":"Extrañar",
		"personal11":"Confidencialidad",
		"personal12":"Cumpleaños",
		"personal13":"Por favor seleccione su fecha de nacimiento",
		"personal14":"Profesión",
		"personal15":"Por favor seleccione su ocupación",
		"personal16":"Por favor ingrese su ocupación (opcional)",
		"personal17":"nación",
		"personal18":"Por favor seleccione su país",
		"personal19":"mantener",
		"personal20":"información personal",
		"personal21":"Seguridad de la cuenta",
		"personal22":"Solo admite imágenes de hasta 2 M",
		"personal23":"¡Subida exitosamente!",
		"personal24":"¡Modificación exitosa!",
		"personal25":"Seguridad de la cuenta",
		"personal26":"Contraseña de inicio de sesión",
		"personal27":"Revisar",
		"personal28":"Correo electrónico",
		"personal29":"reemplazar",
		"personal30":"Cancelación de cuenta",
		"personal32":"¿Está seguro de que desea cancelar su cuenta?",
		"personal33":"Después de cerrar la sesión, se borrará todo el contenido de su cuenta, así que proceda con precaución.",
		"personal34":"Cancelar",
		"personal35":"Seguro",
		"personal36":"Autenticación",
		"personal37":"Para confirmar que es usted quien realiza la operación, complete la verificación de identidad mediante el código de verificación de correo electrónico.",
		"personal38":"Correo",
		"personal39":"Código de verificación",
		"personal40":"Por favor, introduzca el código de verificación",
		"personal41":"Siguiente paso",
		"personal42":"Configurar un nuevo buzón de correo",
		"personal43":"Correo",
		"personal44":"Por favor, introduzca una nueva dirección de correo electrónico",
		"personal45":"Código de verificación",
		"personal46":"Por favor, introduzca el código de verificación",
		"personal47":"Seguro",
		"personal48":"Establecer una nueva contraseña de inicio de sesión",
		"personal49":"Nueva contraseña de inicio de sesión",
		"personal50":"Por favor ingrese una nueva contraseña",
		"personal51":"Confirmar nueva contraseña",
		"personal52":"Por favor, introduzca su nueva contraseña de nuevo",
		"personal53":"Seguro",
		"personal54":"Conseguir",
		"personal55":"Error de formato de correo electrónico",
		"personal56":"¡Reemplazo exitoso!",
		"personal57":"Establezca la contraseña entre 6 y 16 caracteres.",
		"personal58":"Las contraseñas ingresadas dos veces no coinciden",
		"personal59":"¡Modificación exitosa!",
		"personal60":"¡Cierre de sesión exitoso!",
	}
}